<ion-content>
  <div class="py-4">
    <ion-list lines="none">
      <ion-item class="pointer-hover py-1 px-4" (click)="select(0)">
        <div slot="start">
          <div [class.color-primary]="value === 0">
            <i class="fa-kit fa-vs-v1 fs-28"></i>
          </div>
        </div>
        <ion-label>
          <div>
            <div class="h5 mb-1">
              {{ 'P00058.card.status.v1' | translate }}
            </div>
            <div class="color-medium">
              {{ 'P00058.speedModal.v1Description' | translate }}
            </div>
          </div>
        </ion-label>

        @if (value === 0) {
          <div slot="end" class="color-primary">
            <i class="fa-regular fa-check"></i>
          </div>
        }
      </ion-item>
      <ion-item class="pointer-hover py-1 px-4" (click)="select(1)">
        <div slot="start">
          <div [class.color-primary]="value === 1">
            <i class="fa-kit fa-vs-v2 fs-28"></i>
          </div>
        </div>
        <ion-label>
          <div>
            <div class="h5 mb-1">
              {{ 'P00058.card.status.v2' | translate }}
            </div>
            <div class="color-medium">
              {{ 'P00058.speedModal.v2Description' | translate }}
            </div>
          </div>
        </ion-label>

        @if (value === 1) {
          <div slot="end" class="color-primary">
            <i class="fa-regular fa-check"></i>
          </div>
        }
      </ion-item>
      <ion-item class="pointer-hover py-1 px-4" (click)="select(2)">
        <div slot="start">
          <div [class.color-primary]="value === 2">
            <i class="fa-kit fa-vs-max fs-28"></i>
          </div>
        </div>
        <ion-label>
          <div>
            <div class="h5 mb-1">
              {{ 'P00058.card.status.max' | translate }}
            </div>
            <div class="color-medium">
              {{ 'P00058.speedModal.maxDescription' | translate }}
            </div>
          </div>
        </ion-label>

        @if (value === 2) {
          <div slot="end" class="color-primary">
            <i class="fa-regular fa-check"></i>
          </div>
        }
      </ion-item>
    </ion-list>
  </div>
</ion-content>

<ion-footer>
  <div class="p-3">
    <div class="row">
      <div class="col-12 text-center">
        <ion-button
          expand="block"
          fill="outline"
          color="medium"
          (click)="dismissModal()"
        >
          {{ 'selectTimeInterval.cancel' | translate }}
        </ion-button>
      </div>
    </div>
  </div>
</ion-footer>
